import { Icon } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { UserDisplayItem } from "./misc";
import styles from "./FirstnameCellContent.module.less";
import { setTrackingId } from "client/Misc/utils";

export type FirstnameCellContentProps = {
	item: UserDisplayItem;
};

export const FirstnameCellContent = (props: FirstnameCellContentProps): ReactElement => {
	const {
		item
	} = props;

	return (
		<div className={styles.root}>
			<span
				{...setTrackingId("value")}
				className={styles.name}
				title={item.firstName}
			>
				{item.firstName}
			</span>

			{(!item.deletionDate && item.isLackingRequiredModule) && (
				<span className={styles.icon}>
					<Icon
						value={{
							kind: "font",
							name: "triangle-exclamation",
							color: "warning"
						}}
						tooltip={localize("_UserDoesNotHaveTheRequiredPackage")}
					/>
				</span>
			)}
		</div>
	);
};
FirstnameCellContent.displayName = "TextCellWithIcon";
